import { IRequirementResponse } from "@wingspanhq/payments/dist/interfaces";
import { selectorIsReviewStrategyApproval } from "./selectorIsReviewStrategyApproval";

export const selectorIsRequirementWithApprovalFlow = (
  requirement: IRequirementResponse
) => {
  return selectorIsReviewStrategyApproval(requirement.reviewStrategy);
};
